import type { ReactNode } from 'react'

export interface KpiTileProps {
  label: string
  value: ReactNode
  /**
   * The second figure the farm must always see alongside the first — the
   * overhead-excluded variant, or the loaded cost next to the cash cost.
   * Never a decoration: §3.5 and §3.6 exist because one number on its own
   * invites the wrong pricing decision.
   */
  secondary?: { label: string; value: ReactNode }
  hint?: string
  tone?: 'default' | 'warn'
}

export function KpiTile({ label, value, secondary, hint, tone = 'default' }: KpiTileProps) {
  return (
    <div className={`kpi-tile${tone === 'warn' ? ' kpi-warn' : ''}`}>
      <p className="kpi-label">{label}</p>
      <p className="kpi-value">{value}</p>
      {secondary ? (
        <p className="kpi-secondary">
          <span className="kpi-secondary-label">{secondary.label}</span>
          <span className="kpi-secondary-value">{secondary.value}</span>
        </p>
      ) : null}
      {hint ? <p className="kpi-hint">{hint}</p> : null}
    </div>
  )
}
